var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0.4 0.4 29 29",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.257 14.86c0 7.953-6.446 14.397-14.396 14.397-7.95 0-14.397-6.444-14.397-14.396C.464 6.913 6.91.464 14.861.464c7.95 0 14.396 6.449 14.396 14.397zm-14.01-9.635c-3.163 0-5.181 1.332-6.766 3.7a.698.698 0 0 0 .158.944l2.014 1.528c.302.229.733.174.968-.123 1.037-1.316 1.748-2.078 3.326-2.078 1.186 0 2.653.763 2.653 1.913 0 .87-.718 1.316-1.889 1.972-1.365.766-3.172 1.718-3.172 4.102v.232c0 .385.312.697.696.697h3.251a.697.697 0 0 0 .697-.697v-.077c0-1.653 4.829-1.721 4.829-6.192 0-3.367-3.493-5.922-6.765-5.922zm-.386 14.396a2.673 2.673 0 0 0-2.67 2.67 2.673 2.673 0 0 0 2.67 2.67 2.673 2.673 0 0 0 2.67-2.67 2.673 2.673 0 0 0-2.67-2.67z",
    id: "9a8c8c38-9633-42a6-b02b-ef32b55257fe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.dcc6fd387b46278eb91a79b621ec0940.svg";
export { ForwardRef as ReactComponent };